import { cloneDeep } from 'lodash';

import { removeEmptyObjects, useCraftProp } from '@/components/builder/utils';

import ImageField from './Field';

export default function ImageProperty({ name }) {
  const { value = {}, setValue } = useCraftProp(name)

  const handleChange = ({ value: newValue }) => {
    const values = cloneDeep({ ...value, ...newValue })
    setValue(removeEmptyObjects(values))
  }

  return <ImageField value={value} onChange={handleChange} />
}
